import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
// Material modules

import { AppRoutingModule } from './app-routing.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppOptions } from './app.options';
// ngx-bootstrap  module
import { ModalModule } from 'ngx-bootstrap/modal';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// Translating module
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// NG select menu
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from './shared/shared.module';
import { ConfigurationService } from './services';
import { ComponentsModule } from './components/components.module';
import { APP_BASE_HREF, DatePipe, DecimalPipe } from '@angular/common';
// import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { StateService } from './services/state.service';
import { AuthenticationService } from './services/authentication.service';
import { SocketService } from './services/SocketService';
import { OrderService } from './services/order.service';
import { AdminModule } from './admin/admin.module';
import { LandingComponent } from './landing/landing.component';
import { ServerMetadataService } from './services/server-metadata.service';
import { DataexchangeService } from './services/dataexchange.service';
import { HttpErrorInterceptorService } from './services/http-error-interceptor.service';
import { RegisterComponent } from './authentication/register/register.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { LoginComponent } from './authentication/login/login.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { StoreModule } from '@ngrx/store';
import { MatchBoardReducer } from './store/state/reducers/matchboard.reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ThemeService } from 'ng2-charts';
import { PathPrefixInterceptor } from './services/path-prefix.interceptor';
import { applicationReducer } from './store/Application/ApplicationReducer';
import { BaxterAuthModule } from '@baxter-jenkins/authenticator';
import { AngularCommonModule, AngularMultiSelectModule } from '@clearing-hub/angular-common';
import { UpdateStaticInfoWidgetModule } from '@baxter-jenkins/update-static-info-widget';

export function preloadProviderFactory(serverMetadataService: ServerMetadataService) {
  return (): Promise<void> => serverMetadataService.initServerMetadata();
}

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: any = {
  providers: [provideAnimations(), provideHttpClient(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }).providers!]
};
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LandingComponent,
    RegisterComponent,
    AuthenticationComponent,
    LoginComponent
  ],
    imports: [
      BaxterAuthModule.forRoot({
        loginUrl: '/api/authentication/login',
        logoutUrl: '/api/authentication/signout',
        userPoolConfigUrl: '/api/authentication/user-pool',
        isRegistrationEnabled: false,
        registerUrl: '/api/authentication/register'
      }),
      UpdateStaticInfoWidgetModule.forRoot(),
      AdminModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        SharedModule,
        ComponentsModule,
        HttpClientModule,
      AngularCommonModule.forRoot({gridColumnsSize: 12}),
        BrowserAnimationsModule,
        ToastrModule.forRoot({timeOut: 7000}),
        ReactiveFormsModule,
        NgSelectModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        DragDropModule,
        AngularMultiSelectModule,
        ButtonsModule.forRoot(),
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
      // TranslateModule.forRoot({
      // }),
      //   TranslateModule.forRoot({
      //     defaultLanguage: 'en',
      //       loader: {
      //           provide: TranslateLoader,
      //           useFactory: translateHttpLoaderFactory,
      //           deps: [HttpClient],
      //         multi: true
      //       }
      //   }),
      TranslateModule.forRoot({
        defaultLanguage: 'en_US',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      TabsModule,
      StoreModule.forRoot({}),
      StoreModule.forFeature('matchboard', MatchBoardReducer),
      StoreModule.forFeature('application', applicationReducer),
      StoreDevtoolsModule.instrument({
        maxAge: 25, // Retains last 25 states
        // logOnly: environment.production, // Restrict extension to log-only mode
      })
    ],
  exports: [
    TranslateModule,
    ButtonsModule,
    ModalModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule
  ],
  providers: [
    // provideAnimations(),
    // provideHttpClient(),
    AuthenticationService,
    ConfigurationService,
    DecimalPipe,
    ThemeService,
    {
      provide: APP_INITIALIZER,
      useFactory: preloadProviderFactory,
      deps: [ServerMetadataService],
      multi: true
    },
    // {
    //   provide: NgxConfigureOptions,
    //   useClass: AppOptions
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      useValue: window['base-href']
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PathPrefixInterceptor,
      multi: true,
    },
    DataexchangeService,
    StateService,
    SocketService,
    OrderService,
    DatePipe,
    // {provide: NgxConfigureOptions, useClass: AppOptions}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
